export default "__VITE_ASSET__7omNyTS4__"